var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4048_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 8.99854C0.4 4.80159 3.80306 1.39854 8 1.39854C12.1969 1.39854 15.6 4.80159 15.6 8.99854C15.6 13.1955 12.1969 16.5985 8 16.5985C3.80306 16.5985 0.4 13.1955 0.4 8.99854ZM6.42857 12.2557C6.72806 12.2557 6.97143 12.0123 6.97143 11.7128V6.28425C6.97143 5.98476 6.72806 5.74139 6.42857 5.74139H5.57143C5.27194 5.74139 5.02857 5.98476 5.02857 6.28425V11.7128C5.02857 12.0123 5.27194 12.2557 5.57143 12.2557H6.42857ZM10.4286 12.2557C10.7281 12.2557 10.9714 12.0123 10.9714 11.7128V6.28425C10.9714 5.98476 10.7281 5.74139 10.4286 5.74139H9.57143C9.27195 5.74139 9.02857 5.98476 9.02857 6.28425V11.7128C9.02857 12.0123 9.27194 12.2557 9.57143 12.2557H10.4286Z",
    fill: "#FFAB00",
    stroke: "#AB9134",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4048_961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.998535)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseActiveIcon);
export default __webpack_public_path__ + "static/media/pauseActiveIcon.06ff28d1724f3b06d18202c6f5cd9af8.svg";
export { ForwardRef as ReactComponent };